import 'css-chunksrc/client/pages/projectPage/budgetPage/section/styles.scss';export default {
  "section": "_section_1fa27_1",
  "heading": "_heading_1fa27_10",
  "title": "_title_1fa27_18",
  "main": "_main_1fa27_24",
  "iconBox": "_iconBox_1fa27_30",
  "icon": "_icon_1fa27_30"
};